<!--
    我的课程-课程详情-单个课件组件
    功能：单个课件组件内容
    说明：版本3.0
-->
<template>
  <div
    :class="isActive?'active':''"
    class="goods-item"
    @click="handlerOper">
    <div class="item-content">
      <img
        v-if="isHasUrl"
        :src="item.cover"
        class="item-img">
      <img
        v-else
        :src="$assets.classDefault"
        class="item-img">
      <div class="item-number">{{ item.index +1 }}</div>
      <!-- <el-popover
        placement="top"
        width="260"
        trigger="hover">
        <div class="tip-content">
          <div class="tip-title"><span>课时名称：</span>{{ item.name }}</div>
          <div class="tip-title"><span>课时标题：</span>{{ item.title }}</div>
        </div>
        <div
          slot="reference"
          class="item-bottom">
          <div class="txt elps">{{ item.name }}</div>
          <div
            class="txt elps"
            style="padding-top:3px">{{ item.title }}</div>
        </div>
      </el-popover> -->
      <div
        class="item-bottom">
        <div class="txt elps">{{ item.name }}</div>
        <div
          class="txt elps"
          style="padding-top:3px">{{ item.title }}</div>
      </div>
      <!-- <div class="item-cover">
        <i class="iconfont icon-suo"/>
       </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'GoodsItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isUnLock: false,
      isPopover: false,
      submitLoading: false,
      isActive: false,
    };
  },
  computed: {
    isHasUrl() {
      let state = false;
      const url = this.item.cover;
      if (url && url.indexOf('default') === -1 && url !== 'https://ucenter.yunkedun.com') {
        state = true;
      }
      return state;
    },
  },
  methods: {
    handlerOper() {
      this.$emit('handler-item', this.item);
    },
    clerActive() {
      this.isActive = false;
    },
    toggleActive() {
      this.isActive = !this.isActive;
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-item{
    margin:10px;
    width: 172px;
    height: 192px;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
    border: 3px solid #fff;
     &:hover{
      .item-img{
        transform: scale(1.2);
        transition: .4s all ease;
      }
    }
     &.active{
    padding: 3px;
    border: 3px dotted #faad14;
    }
}
.item-content{
    width: 100%;
    height: 100%;
    border:1px solid #eee;
    box-sizing: border-box;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    .item-number{
    position: absolute;
    left: 10px;
    top: 10px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #FFFFFF;
    border-radius: 4px;
    color:#303133;
    font-size: 14px;
    }
    .item-img{
    position: absolute;
    left: 0;
    top: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
    }
    .item-cover{
      width: 100%;
      height: 100%;
      position: absolute;
      left: 50%;
      top:50%;
      transform: translate(-50%,-50%);
      background-color: rgba($color: #000000, $alpha: .5);
      z-index: 4;
      display: flex;
      justify-content: center;
      align-items: center;
      .iconfont{
            color: #fff;
            font-size: 26px;
        }
    }
    .item-bottom{
      width: 100%;
      height: 52px;
      position: absolute;
      left: 0;
      bottom: 0;
      text-align: center;
      color: #fff;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: rgba($color: #000000, $alpha: .4);
      }
}
.tip-img{
  width: 100%;
}
.tip-content{
  min-height: 100px;
}
.tip-title{
  color: #606266;
  padding: 5px 0;
  span{
    font-weight: 600;
    color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MyCourse/packageDetail/components/goods-item.vue